export default "__VITE_ASSET__BLL9VYFe__"